/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type RescheduleHistoryItemDto = {
    /**
     * Reschedule record UUID
     */
    id: string;
    /**
     * Reschedule status
     */
    status: RescheduleHistoryItemDto.status;
    /**
     * Previous session date/time (ISO)
     */
    previousDate: string;
    /**
     * New session date/time (ISO)
     */
    newDate?: Record<string, any> | null;
    /**
     * Reason for reschedule, or "-" if none
     */
    reason: string;
    /**
     * Name of user who performed the reschedule request
     */
    performedBy: string;
    /**
     * When expert raised: whether client accepted. "Yes" | "No" | "Pending", else "-"
     */
    acceptedByClient?: Record<string, any> | null;
};
export namespace RescheduleHistoryItemDto {
    /**
     * Reschedule status
     */
    export enum status {
        PENDING = 'pending',
        ACCEPTED = 'accepted',
        DECLINED = 'declined',
    }
}

